import {flightTypes, workplaceTypes} from "../types";
import {DepartureFlightInfoBlock} from "../FlightBlock/DepartureFlightInfoBlock";
import {ArrivalFlightInfoBlock} from "../FlightBlock/ArrivalFlightInfoBlock";
import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';

export var FlightInfoPage = {
    controller: function () {
        var self = this;

        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();

        loader.show();

        if (user.get('state.workplace') === workplaceTypes.security) {
            this.topMenu = [
                { title: 'Рейсы', url: '/security/flights', icon: 'fa-plane' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        } else if (user.get('state.workplace') === workplaceTypes.driver) {
            this.topMenu = [
                { title: 'Свободные', url: '/vehicle/tasks/free', icon: 'fa-car' },
                { title: 'Задачи', url: '/vehicle/tasks', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        }

        this.data = m.request({
            method: 'GET',
            url: '/api/flight/' + m.route.param('flightId') + '/info'
        }).then(function (response) {
            server.setOnline();
            loader.hide();
            storage.config = response.config;

            server.initPing();

            return response;
        }, function (response) {
            if (response && response.message) {
                self.errmsg = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    view: function (ctrl) {
        return [
            m.component(HeaderMenuBlock, {
                time: ctrl.data().time,
                menu: ctrl.topMenu
            }),
            m(".bg-primary[style='padding:7px;margin-top:0px']", [
                m(".container.text-center", [
                    m("div[style='display:inline-block;margin-right:15px']", "Борт: " + (ctrl.data().board.boardNumber || '') + " [" + ctrl.data().board.flightChain + "] "),
                    ctrl.data().board.alertsExists ? m("i.fa.fa-warning", {
                        onclick: function () {
                            alert(ctrl.data().board.alerts.map(function(alert) {
                                return "[" + alert.code + "] " + alert.desc + " - " + alert.amount;
                            }).join("\n"));
                        }
                    }) : ''
                ])
            ]),
            ctrl.errmsg,
            ctrl.data().info.type === flightTypes.departure ?
                m.component(DepartureFlightInfoBlock, {
                    data: ctrl.data().info,
                    showBookingBlock: false
                }) :
                m.component(ArrivalFlightInfoBlock, {
                    data: ctrl.data().info,
                    showBookingBlock: false
                })
        ];
    }
};
